module.exports = __webpack_public_path__ + "static/humans_kalishits-18c7ea26325ac1d0748304666f889194.png";